import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";
import { TESTIDS } from "@/constants/testIds";

const WA = "https://wa.me/56936400479?text=Hola%2C%20quiero%20cotizar%20una%20base%20de%20datos";

export default function Footer() {
  return (
    <footer
      data-testid={TESTIDS.footer}
      className="relative border-t border-[rgba(0,240,255,0.12)] bg-[#020610] pt-16 pb-10"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10 mb-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2 mb-5">
              <div className="w-9 h-9 rounded-md bg-[#0a1224] border border-[rgba(0,240,255,0.4)] flex items-center justify-center">
                <span className="font-display font-black text-[#00f0ff] text-sm">CDP</span>
              </div>
              <div className="font-display font-bold text-white text-lg">
                Chile<span className="text-[#00f0ff]">Datos</span>Pro
              </div>
            </div>
            <p className="text-[14px] text-[#94a3b8] leading-relaxed max-w-md mb-5">
              Bases de datos B2B personalizadas para empresas en Chile.
              Contactos verificados, segmentados y en cumplimiento con la nueva
              Ley 21.719.
            </p>
            <div className="flex items-center gap-2 px-3 py-2 rounded-full border border-[rgba(0,240,255,0.2)] bg-[rgba(0,240,255,0.05)] w-fit">
              <span className="w-2 h-2 rounded-full bg-[#00f0ff] shadow-[0_0_8px_#00f0ff]" />
              <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#00f0ff]">
                Cumplimiento Ley 21.719
              </span>
            </div>
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#00f0ff] mb-5">
              Navegación
            </h4>
            <ul className="space-y-3">
              {[
                { id: "servicios", label: "Servicios" },
                { id: "cumplimiento", label: "Ley 21.719" },
                { id: "porque", label: "Por qué nosotros" },
                { id: "faq", label: "Preguntas frecuentes" },
                { id: "contacto", label: "Contacto" },
              ].map((l) => (
                <li key={l.id}>
                  <a
                    href={`/#${l.id}`}
                    className="text-[14px] text-[#94a3b8] hover:text-[#00f0ff] transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
              <li>
                <Link
                  to="/datos-para-ia"
                  data-testid="footer-datosia-link"
                  className="text-[14px] text-[#94a3b8] hover:text-[#00f0ff] transition-colors"
                >
                  Datos para IA y datasets personalizados
                </Link>
              </li>
              <li>
                <Link
                  to="/blog/comprar-datos-contactos-empresas-chile"
                  data-testid="footer-blog-link"
                  className="text-[14px] text-[#94a3b8] hover:text-[#00f0ff] transition-colors"
                >
                  Blog: Comprar datos de contactos
                </Link>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h4 className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#00f0ff] mb-5">
              Contacto
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="text-[#00f0ff] mt-0.5 shrink-0" size={16} />
                <span className="text-[14px] text-[#94a3b8]">
                  Santiago de Chile
                </span>
              </li>
              <li>
                <a
                  href={WA}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={TESTIDS.footerWhatsapp}
                  className="flex items-start gap-3 group"
                >
                  <Phone className="text-[#00f0ff] mt-0.5 shrink-0" size={16} />
                  <div>
                    <div className="text-[14px] text-white group-hover:text-[#00f0ff] font-medium transition-colors">
                      +56 9 3640 0479
                    </div>
                    <div className="text-[11px] text-[#64748b] font-mono uppercase tracking-wider">
                      WhatsApp · Lun a Vie
                    </div>
                  </div>
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="text-[#00f0ff] mt-0.5 shrink-0" size={16} />
                <span className="text-[14px] text-[#94a3b8]">
                  Cotiza directo por WhatsApp
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-[rgba(0,240,255,0.1)] flex flex-col sm:flex-row justify-between items-center gap-3">
          <div className="font-mono text-[11px] text-[#64748b] uppercase tracking-wider">
            © {new Date().getFullYear()} Chile Datos Pro · Todos los derechos reservados
          </div>
          <div className="font-mono text-[11px] text-[#64748b] uppercase tracking-wider">
            Hecho en Santiago de Chile 🇨🇱
          </div>
        </div>
      </div>
    </footer>
  );
}
